import React, { Component } from 'react';
import FormHandler from 'AdminApp/common/script/services/crud/FormHandler';
import LoginModel from 'AdminApp/common/script/models/security/LoginModel';
import InputField from 'AdminApp/common/script/components/ui/InputField';
import { connect } from 'react-redux';
import { loginTriggerAction } from 'AdminApp/modules/auth/AuthActions';
import { Link } from 'react-router-dom';
import FormSubmitWrapper from 'AdminApp/common/script/components/crud/FormSubmitWrapper';

const mapDispatchToProps = dispatch => {
  return {
    userLoggedIn: (token, account) => {
      return dispatch(loginTriggerAction(token, account))
    }
  }
}

@connect(null, mapDispatchToProps)
export default class LoginPage extends Component {

  componentDidMount() {
    // $('#slide-login').slideToSubmit({
    //   successText: 'You are logged in...'
    // });
    this.setState({
      record: {
        ...this.state.record,
        email: '',
        password: ''
      }
    })
  }
  /**
     * Constructor
     *
     * @param props
     */
  constructor(props) {
    super(props);
    // Initial state
    this.formHandler = new FormHandler(this, new LoginModel({
      email: ' ',
      password: ' '
    }));
  }

  onSubmitSuccess(data) {
    if (data.success && data.data.token) {
      this.props.userLoggedIn(data.data.token, data.data.account);
    }
  }
  _getModalMessage(data) {
    if (!data.success) {
      return data.errors[0].message
    }
  }

  /**
   * Render template
   *
   * @returns {XML}
   */
  render() {
    let formHandler = this.formHandler;
    return (
      <div>
        <h2>LOGIN</h2>
        <FormSubmitWrapper showBtn={false} formHandler={formHandler} to='/login' buttonText='Login' getModalMessage={data => this._getModalMessage(data)}>
          <InputField
            materialProps={{
              fullWidth: true
            }}
            autoComplete={this.state.record.email}
            classes={'loginInput'}
            label="Email *"
            type="email"
            name="email"
            InputLabelProps={{
              shrink: true,
            }}
            value={this.state.record.email}
            handler={formHandler} />
          <InputField
            materialProps={{
              fullWidth: true
            }}
            autoComplete={this.state.record.password}
            label="Password *"
            type="password"
            name="password"
            InputLabelProps={{
              shrink: true,
            }}
            value={this.state.record.password}
            handler={formHandler} />
          <Link className="form-sublinks forgot-password" to="/login/reset-password">Forgot Password?</Link>

          {formHandler.getSubmissionStatus()}
        </FormSubmitWrapper>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/login/LoginPage.js